<div class="content">
  <div class="error-code">404</div>

  <div class="message">{{ 'notFound_description' | translate:locale.language }}</div>

  <a class="back-link" href="/">{{ 'notFound_back_button' | translate:locale.language }}</a>
</div>